function envIsTruthy(raw: string | undefined): boolean {
  if (raw === undefined || raw === '') return false
  return ['1', 'true', 'yes', 'on'].includes(raw.trim().toLowerCase())
}

/**
 * When true, Unifier + Procore UI copy and menu/hotspot icons use “Autodesk Build” branding.
 * When false, copy stays on Unifier/Procore naming and menu/hotspot icons use the Unifier logo.
 * Set at **build time** in `.env`: `REACT_APP_AUTODESK_BUILD_INTEGRATION=true`
 * (Create React App only exposes `REACT_APP_*` to the browser bundle.)
 */
export const isAutodeskBuildIntegrationBranding = envIsTruthy(
  process.env.REACT_APP_AUTODESK_BUILD_INTEGRATION,
)
